import React, { useEffect } from "react";
import "../App.css";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <nav
        className="navbar"
        style={{
          backgroundImage: "url(/images/Hero.png)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="nav-container"
          onClick={() => (window.location.href = "/")}
        >
          <div className="logo">
            <img src="/images/logo.png" alt="Logo" />
          </div>

          <button className="nav-button">
            <a href="tel:+919602326570">Call Us +91-9602326570</a>
          </button>
        </div>
      </nav>

      <h3 className="tncHeading">Terms and Conditions</h3>
      <div className="text-container">
        <p className="bold-pg">
          PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY. BY USING THIS
          WEBSITE AND/OR PLATFORM YOU AGREE TO BE BOUND BY ALL OF THE BELOW
          TERMS AND CONDITIONS AND PRIVACY POLICY.
        </p>
        <p className="normal-pg">
          The domain name and the brand name www.zivoro.ai (hereinafter referred
          to as the "Website") is absolutely owned and operated by Jewel Nexus
          Technologies Private Limited, a company incorporated under the
          Companies Act, 2013 with its registered office at No.42, H.No.7, Sri
          Rama Building Royal Placid Layout, Phase 1, Haralur Main Road,
          Bangalore 560102, exclusively creates and manages webstore(s) for
          other Jewellers (together "Company", "We" or "Us" and their
          connotations) and operates it under the domain and sub-domain
          www.zivoro.ai (Websites), a mobile application "jewellers live"
          available on Google play store and Apple app store (App), and the
          uniform resource locator and/or mobile application created for each
          Merchant (Merchant Platform) (the Websites, the App, and the Merchant
          Platform together called as "Platform"). The users of the Platform
          shall mean to include any individual or corporate body, who has agreed
          to become a user of the Platform by accessing or using the Platform,
          including but not limited to jewellers (Merchants) or their customers
          (Customers) and are herein referred to as "Users". The term "Users"
          for the purposes of these terms shall be read as "You" and its
          connotations and shall mean the Merchants and/or Customers as the
          context may so prescribe. These terms and conditions (Terms) describe
          the terms on which the Company grants Users access to the Platform and
          certain provisions may apply specifically to only one class of the
          User depending on whether the Platform is being accessed by the
          Customer or the Merchant and shall be read with the privacy policy
          available. In the event that you are a Merchant, Part (A) of these
          Terms shall specifically apply to you. In the event that you are a
          Customer, Part (B) of these Terms shall specifically apply to you.
          Part (C) of these Terms shall apply to the Merchants as well as the
          Customers. These Terms shall apply fully to your use or access of this
          Platform. By using or accessing this Platform, you agree to accept all
          Terms written in here. You must not use or access this Platform if you
          disagree with these Terms. Minors or people below 18 years old are not
          allowed to use this Platform and any person below the age of 18 years
          availing the Services shall be deemed to have obtained parental
          consent to do so.
        </p>
        <p className="sub-heading">SERVICES</p>
        <p className="normal-bg">The Company via its Platform;</p>
        <p className="normal-bg">
          a) enables the Merchants to offer products or service including but
          not limited to gold jewellery, silver jewellery, Diamond jewellery,
          Gemstones, loose diamonds, coins, bars, digital gold, gold loans,
          purchase plans/schemes, online payment options to the Customers and
          (Merchant Services) By virtue of this Platform, the Customers or
          Merchants shall be able to choose and avail Merchant Services. It is
          hereby clarified that the Company is not rendering the Merchant
          Services to Customers, directly by itself, and it is merely providing
          a Platform to its Users and facilitating the transaction related to
          Merchant Services being offered by the applicable Merchant. You hereby
          acknowledge that the Company only facilitates the transactions related
          to Merchant Services through this Platform and will not be liable in
          any manner whatsoever with respect to any of the Merchant Services
          being offered to You.
        </p>
        <p className="sub-sub-heading">(A) TERMS APPLICABLE ON MERCHANTS</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant undertakes to provide accurate and correct information
            while registering on the Platform and while offering Merchant
            Services. The Merchant shall provide all such documents as and when
            required by the Company. In case of any changes in the
            aforementioned information, the Merchant shall immediately inform
            the Company in writing and rectify the information. The Merchant
            agrees and confirms that we may review the information provided and
            undertake any appropriate due diligence. However, we shall not be
            liable for any loss or damage caused to the Merchant due to
            submission of inaccurate information.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant hereby represents and warrants that it has all the
            necessary rights, consents, and permissions for the content that is
            being transmitted, displayed, stored through the Platform and that
            no content will violate or infringe any (i) third party intellectual
            property, publicity, privacy or other rights or (ii) any laws.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant shall at all times be responsible for maintaining the
            quality, authenticity and sanctity of the Merchant Services that is
            being sold through the Platform. The Merchant shall not hold the
            Company liable for any issues owing to quantity and/or quality of
            the Merchant Services or for any issues related to the delivery of
            the Merchant Services and at all times indemnify the Company in case
            of any third party or Customer claim.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant is solely responsible for the quoted prices of Merchant
            Services on our Platform, for selling and/or delivering the Merchant
            Services to the Customer, for storage, fulfilment of any order
            placed by the Customer, and for any deficiency in the Merchant
            Services performed by the Merchant.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant is the operator of the specific purchase plan as
            introduced by it from time to time and entered into by and between
            the Merchant and the respective Customers. Such purchase plans will
            be governed by the terms and conditions of the respective purchase
            plan.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Any disputes arising between the Customer and the Merchant shall be
            resolved by the Merchant at its sole and absolute liability. The
            Merchant hereby agrees to absolve the Company from any liability
            arising from these Terms as well as the applicable purchase plan
            terms. In an event, where the Company is made a party to any
            dispute, the Merchant hereby agrees to indemnify the Company for any
            loss suffered.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The usage of certain services and features of the Platform are
            subject to usage charges (Platform Fees). The Platform Fees for
            usage of a feature or services will be either published on the
            Platform or communicated directly to the Merchant. In consideration
            of using a paid service or a paid feature of the Platform, the
            Merchant hereby unconditionally agrees to pay the respective
            Platform Fees to the Company. The Merchant further agrees that the
            Platform Fees is subject to change by the Company and such change
            shall be accepted by the Merchant, from time to time.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Merchant grant the Company unconditional and irrevocable right
            to deduct the Platform Fees directly from any amount received by the
            Company from Customers for the Merchant Services. The Merchant agree
            to settle any Platform Fees that has not been ● ● automatically
            deducted by the Company on a monthly basis. Any pending payments
            beyond this will incur a penalty fees of 5% per month.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            In order to facilitate the provision of Merchant Services between
            the Merchants and Customers, the Company provides payment facility
            as a feature on the Platform either directly or through a third
            party service provider at its sole discretion (Payment Gateway).
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Company directly or via the relevant third party service
            provider shall transfer the amount paid by the Customer using
            Payment Gateway (after deducting the Platform Fees) in the
            Merchant's account, within 2 working days from Customer being in
            receipt of such Merchant Services.
          </li>
        </ul>
        <p className="sub-sub-heading">(B) TERMS APPLICABLE ON CUSTOMERS</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Customer agrees that the prices for Merchant Services reflected
            on our Platform are being managed, controlled and operated by the
            applicable Merchant and we do not determine, set forth, or control
            the prices offered by Merchants in any manner. For certain
            transactions, the Customer shall bear fees and charges in addition
            to payment for prices displayed on the Platform. Such additional
            fees and charges shall be as are appearing on the Platform. The
            Customer agrees to pay attention to the details of the transactions
            entered into by them, because the total price for a transaction may
            include taxes, fees and shipping costs (as the case maybe), which
            the Customer is responsible for paying. We assume no liability for
            the accuracy of any pricing, the content of displayed images or any
            other associated information in relation to Merchant Services
            displayed by Merchant on our Platform.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Customer hereby agrees to undertake the sole responsibility
            towards providing us with the accurate and correct information while
            registering to our Platform and while using Merchant Services. In an
            event, where the Customer believes that an information provided has
            any error or has changed from the original information provided, the
            Customer shall immediately inform us in writing and forthwith
            rectify the information. The Customer agrees and confirms that we
            may review the information provided and undertake any appropriate
            due diligence. However, we shall not be liable for any loss or
            damage caused to the Customer due to submission of inaccurate
            information.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Customer agrees and understands that the applicable Merchant is
            solely responsible for the delivery and fulfilment of Your order.
            You shall not hold the Company liable for any issues owing to
            quantity and/or quality or for any issues related to the delivery of
            the Merchant Services.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Customer shall be solely responsible for providing accurate
            payment information. You agree that all information that you will
            provide is accurate, complete and current and that payments means
            (including but not limited to credit card/debit card/net
            banking/upi) used by you is lawfully owned by You. You will pay all
            payment owed, including any applicable taxes for the respective
            Merchant Service and the Company or the Merchant will not be
            responsible for any delay or refusal in authorization of payment by
            Your Bank or financial institution. In case of a delay or refusal of
            the payment, the Merchant shall have the right to delay or cancel
            the order of the Merchant Service without any further liability. You
            hereby agree that We cannot reverse any payment that has been made
            through our Platform. Your sole recourse for any issues related to
            payment will be to contact the Merchant for a resolution.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You agree and acknowledge that the Merchant has the sole liability
            to maintain purity and authenticity, deliver accurate ordered
            quantity in terms of weight and measurement, content and fitness and
            associated aspects for the Merchant Services through our Platform.
            Additionally, the Merchant shall have the sole liability towards
            raising invoices, providing for any warranty, provide any post sale
            support and the Company will not have any liability on these account
            in any manner, whatsoever.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You shall raise any concern that you might have related to Merchant
            Services that has been transacted through the Platform with the
            applicable Merchant. The Platform will allow for facilitation of any
            grievances / complaints associated to any transaction that has been
            made through it.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Customer acknowledges and agrees to the effect that in the event
            he opts/avails for any purchase plan made available by any
            applicable Merchant, the purchase plan shall govern the terms of
            such purchase. You hereby agree that your relationship with the
            applicable Merchant will be governed by the terms of the
            aforementioned purchase plan. You agree to have carefully read and
            acknowledge all applicable terms and conditions before entering into
            any transaction with a Merchant through our Platform.
          </li>
        </ul>
        <p className="sub-sub-heading">(C) GENERAL TERMS</p>
        <p className="normal-pg">
          Please note that Part (C) of these Terms shall apply to the Merchant
          and as well the Customers.
        </p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            For accessing and using the Platform You might be required to create
            a username and password and/or use mobile verification and/or use
            email verification (together Login Details). You are responsible for
            what you do with your Login Details including maintaining the
            security, safety, and confidentiality. You agree and acknowledge
            that anybody with Your Login Details will be able to use Your
            account as You would and perform any actions as You would. You shall
            immediately notify the Company of any actual or suspected
            unauthorized use of Your Login Details. You will be solely
            responsible for any such access and/or losses incurred by You and
            the Company will have no liability whatsoever in such cases.
            However, you shall be liable for any losses suffered by the Company
            or such other parties as the case may be, due to any unauthorized
            use of Your account.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You acknowledge and confirm to the effect that our role is limited
            to providing a Platform facilitating all of Merchant Services. We
            are not to be construed as a marketplace to provide any such
            services to Customers or Merchants. We are neither acting as a
            seller of any Merchant Services being offered nor are we responsible
            for fulfilment of the order in any manner.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You agree that the Company based on internal policies, statutory and
            regulatory requirements may report any transaction to appropriate
            authorities in case any transaction is classified as suspicious or
            fraudulent and We shall not be liable for any loss caused to You for
            such reporting required under law, even if such transaction is later
            deemed to be lawful at any stage.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You agree that each Merchant Services may have specific terms and
            conditions associated with them and You by using those Merchant
            Services agree to be legally bound and govern by those terms and
            conditions along with the Terms and the Privacy Policy.
          </li>
        </ul>
        <p className="sub-heading">LICENSE TO USE</p>
        <p className="normal-bg">
          Company hereby grants you the limited right to access, view and use
          the Platform only for the purposes of providing or availing the
          Merchant Services. Any rights not expressly granted to you herein are
          reserved to the Company.
        </p>

        <p className="sub-heading">RESTRICTIONS ON USE</p>
        <p className="normal-bg">
          You must comply with the laws that apply to you in the location that
          you access Platform or its services from. If any laws applicable to
          you restrict or prohibit you from using the Platform or its services
          you must comply with those legal restrictions or, if applicable, stop
          accessing and/or using the Platform or its services. You promise that
          all the information you provide to Company on accessing and/or using
          the Services is and shall remain true, accurate and complete at all
          times. <br />
          <br />
          Notwithstanding anything, you are specifically restricted from all of
          the following:
        </p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Publishing any Platform material in any other media unless expressly
            permitted by the Company
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Selling, sublicensing and/or otherwise commercializing any Platform
            material
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Publicly performing and/or showing any Platform material without the
            Company's prior written consent
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Using this Platform in any way that is or may be damaging to this
            Platform
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Using this Platform in any way that impacts user access to this
            Platform
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Using this Platform contrary to applicable laws and regulations, or
            in any way may cause harm to the Platform, us or to any person or
            business entity
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Engaging in any data mining, data harvesting, data extracting or any
            other similar activity in relation to this Platform
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Duplicating, downloading, reproducing, exploiting or creating any
            derivative works of the Platform material
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Framing or utilizing any framing techniques to capture any
            trademark, logo, or other proprietary information in any form
            belonging to the Company without its express written consent
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Using this Platform to engage in any advertising or marketing unless
            expressly permitted by the Company.
          </li>
          <p className="normal-bg"></p>
        </ul>
        <p className="sub-heading">AGREEMENT TO RECEIVE COMMUNICATION</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You hereby agree for the receipt of communication and newsletters
            from zivoro.ai by way of e-mails and/or SMS notifications. You shall
            intimate zivoro.ai immediately of any changes to contact. By
            accepting these Terms, You further authorize zivoro.ai to get in
            touch with You for communication and promotions, despite any Do Not
            Disturb requests made by You.
          </li>
        </ul>

        <p className="sub-heading">FEEDBACK</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Platform may allow You to post Your review and experience of
            using the Platform in order to improve the user experience.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You represent that all such Reviews will be in accordance with
            applicable law. You acknowledge that zivoro.ai does not endorse any
            Reviews on the Platform and is not responsible or liable for any
            Reviews.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            zivoro.ai reserves the right to disable access to the Reviews on the
            Website to disable access on any part of the Platform.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You hereby grant zivoro.ai an absolute right to use, copy,
            distribute, display, publish, transmit, make available, reproduce,
            modify, adapt the Reviews in any manner as deemed appropriate by
            zivoro.ai in any form including but not limited to print, broadcast,
            online and across any and all websites and platforms owned by
            zivoro.ai.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You further represent and warrant that while posting any Reviews on
            any part of the Platform You shall not use any offensive, libelous,
            derogatory, hateful or racially or ethnically objectionable
            language. Further, You shall not post any content on any part of the
            Platform that is obscene, pornographic.
          </li>
        </ul>

        <p className="sub-heading">CONFIDENTIALITY</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            As provided in the Privacy Policy, all confidential information,
            including Your personal information, shall not be shared/disclosed
            to anyone except as required by law, and shall ensure that such
            confidential information is protected with adequate security
            measures.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            zivoro.ai acknowledges that only its employees, directors, agents
            and contractors shall use the confidential information only for the
            intended purpose provided for. zivoro.ai shall take all reasonable
            meaures to ensure that its employees, directors, agents and
            contractors acknowledge and comply with the provisions of these
            Terms of confidentiality as if such person was subject to these
            Terms of confidentiality.
          </li>
        </ul>
        <p className="sub-heading">LINKS TO THIRD-PARTIES' WEBSITES</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The Website or any other part of the Platform may contain links and
            interactive functionality interacting with the websites of third
            parties. zivoro.ai is not responsible for and has no liability for
            the functionality, actions, inactions, privacy settings, privacy
            policies, terms, or content of any such website. Before enabling any
            sharing functions to communicate with any such website or otherwise
            visiting any such website, zivoro.ai strongly recommends that You
            review and understand the terms and conditions, privacy policies,
            settings, and information-sharing functions of each such third-party
            website. for the functionality, actions, inactions, privacy
            settings, privacy policies, terms, or content of any such website
            and/or mobile based software applications/programs (as may be
            applicable) and/or any liability whatsoever in relation to Your use
            of such website and/or mobile based software applications/programs
            (as may be applicable) save and except to the extent expressly set
            out in these Terms. Before enabling any sharing functions to
            communicate with any such website or otherwise visiting any such any
            such website and/or mobile based software applications/programs (as
            may be applicable), zivoro.ai strongly recommends that You review
            and understand the terms and conditions, privacy policies, settings,
            and information-sharing functions of such any such website and/or
            mobile based software applications/programs (as may be applicable).
          </li>
        </ul>
        <p className="sub-heading">INDEMNIFICATION</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You shall indemnify and hold harmless zivoro.ai, its owner,
            licensee, affiliates, subsidiaries, dealers, group companies (as
            applicable) and their respective officers, directors, agents, and
            employees, from any claim or demand, or actions including reasonable
            attorneys' fees, made by any third party or penalty imposed due to
            or arising out of Your breach of these Terms, Privacy Policy and
            other policies, or Your violation of any law, rules or regulations
            or the rights (including infringement of any intellectual property
            rights) of a third party.
          </li>
        </ul>
        <p className="sub-heading">TERMINATION</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            zivoro.ai may suspend, or terminate access to, all or any portion of
            the Platform or Your ability to access any Services through the
            Platform at any time for any reason including termination for breach
            of any of these Terms or privacy policy or for any other action
            prejudice to zivoro.ai.within 24-48 hrs from the time of request
            placed.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            These Terms shall further stand terminated:
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            if zivoro.ai is adjudged bankrupt or declared insolvent
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            if zivoro.ai ceases to carry on its business or has communicated to
            the Security Trustee any intention to cease to carry on its business
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            if zivoro.ai breaches any of the terms and conditions under the
            Security Trustee Agreements or Terms and zivoro.ai does not remedy
            such breach within 60 (Sixty) days of being called upon to do so by
            the Security Trustee
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            upon any corporate action (excluding any third-party corporate
            action), legal proceedings or other procedures or steps being taken
            in relation to the suspension of payments, winding up, dissolution,
            administration, provisional supervision or reorganization or
            restructuring (by way of voluntary arrangement, scheme of
            arrangement or otherwise) of zivoro.ai
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            upon zivoro.ai commencing a voluntary proceeding under any
            applicable bankruptcy, insolvency, winding up or other similar
            applicable law now or hereafter in effect, or consenting to the
            entry of an order for relief in an involuntary proceeding under any
            such applicable law, or consenting to the appointment or taking
            possession by a receiver, liquidator, assignee (or similar official)
            for the whole or a substantial part of its property or takes any
            action towards its re-organization, liquidation or dissolution
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            upon an order being made for the winding up, bankruptcy or
            dissolution of zivoro.ai, or an application is admitted for
            initiating any corporate insolvency resolution process against
            zivoro.ai in accordance with Applicable Law
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            upon any encumbrancer lawfully taking possession, or a liquidator,
            judicial custodian, receiver, administrative receiver or trustee or
            any analogous officer having been appointed in respect of the whole
            or a substantial part of the property of zivoro.ai, or an
            attachment, sequestration, distress or execution (or analogous
            process) being levied or enforced upon or issued against whole or a
            substantial part of the assets or property of zivoro.ai, or any
            action has been taken or suffered against zivoro.ai towards
            liquidation or dissolution or similar reorganization; or
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            upon a liquidator or provisional liquidator being appointed to
            zivoro.ai or a receiver, receiver and manager, trustee or similar
            official being appointed in respect of zivoro.ai or any of its
            assets, or an event analogous.
          </li>
        </ul>
        <p className="sub-heading">CONSEQUENCES OF TERMINATION</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Upon such termination for any reason whatsoever, subject to these
            Terms : Gold holdings of less or more than 1 (One) gram may be sold
            and cash in pursuance thereto will be sent directly to Your bank
            account, after deducting all the requisite charges relating to
            appointment of Intermediaries including but not limited to charges
            due and payable to Intermediaries and any other out of pocket
            expenses, custody charges, minting and delivery charges .
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You agree that zivoro.ai shall not be liable for any discontinuation
            or termination of Services by any third party
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            None of Your content shall remain accessible on the Website upon
            termination. This information cannot be recovered by You, once the
            account is terminated.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            The disclaimer of warranties, the limitation of liability, and the
            governing law provisions shall survive any termination of these
            Terms.
          </li>
        </ul>
        <p className="sub-heading">DISCLAIMER OF WARRANTIES</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            THE WEBSITE AND ALL INFORMATION, CONTENT, MATERIALS AND SERVICES
            INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE PLATFORM
            (COLLECTIVELY, THE "CONTENTS") ARE PROVIDED BY ZIVORO.AI ON AN "AS
            IS, " "AS AVAILABLE" BASIS, WITHOUT REPRESENTATIONS OR WARRANTIES OF
            ANY KIND. ZIVORO.AI MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY
            KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE PLATFORM, THE
            ACCURACY OR COMPLETENESS OF THE CONTENTS AND THE ACCURACY OF THE
            INFORMATION. ZIVORO.AI SHALL HAVE NO RESPONSIBILITY FOR ANY DAMAGE
            TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE
            DOWNLOAD OF ANY CONTENT, MATERIALS, DOCUMENT OR INFORMATION OR ANY
            OTHER LOSSES INCURRED BY YOU FOR USE OF THE WEBSITE. YOU EXPRESSLY
            AGREE THAT THE USE OF THE PLATFORM IS AT YOUR SOLE RISK. ZIVORO.AI
            WILL NOT BE LIABLE FOR ANY DAMAGES OF ANY KIND ARISING FROM THE USE
            OF THE PLATFORM OR THE SERVICES OR THE CONTENTS INCLUDING, WITHOUT
            LIMITATION, DIRECT, INDIRECT, CONSEQUENTIAL, PUNITIVE, AND
            CONSEQUENTIAL DAMAGES, UNLESS OTHERWISE SPECIFIED IN WRITING. TO THE
            FULL EXTENT PERMITTED BY LAW, ZIVORO.AI DISCLAIMS ANY AND ALL
            REPRESENTATIONS AND WARRANTIES WITH RESPECT TO THE PLATFORM (OR ANY
            PART THEREOF) AND ITS CONTENTS, WHETHER EXPRESS OR IMPLIED,
            INCLUDING, WITHOUT LIMITATION, WARRANTIES OF TITLE, MERCHANTABILITY,
            AND FITNESS FOR A PARTICULAR PURPOSE OR USE.
          </li>
        </ul>

        <p className="sub-heading">LIMITATION OF LIABILITY</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You hereby acknowledge that company (including but not limited to
            its, directors, employees, agents or partners) shall not be held
            liable to You for any special, consequential, incidental, and
            exemplary or punitive damages, or loss of profit or revenues.
            Company shall also not be liable under any circumstances for damages
            arising out or related in any way to Your inability to access, or
            Your difficulty in accessing the Platform or any bugs, viruses,
            trojan horses, or the like, which may be transmitted to or through
            the Platform by any third party, any loss of Your data, any claim
            relating to Your data or content from the Services, Your failure to
            keep the Customer Account Information secure and confidential. You
            further agree that the company shall not be held responsible in any
            manner whatsoever for any and all acts of the Intermediaries.
          </li>
        </ul>
        <p className="sub-heading">CONTENT AND INTELLECTUAL PROPERTY RIGHTS</p>

        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Company solely and exclusively owns copyrights, trademarks, service
            marks, logos, trade names, and other intellectual and proprietary
            rights associated with the Services and content on the Website as
            well as any content provided by company and displayed on/accessed
            except for any images uploaded by the partnered stores for exchange
            of digital gold for jewelry via
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            (i) any website(s) operated by zivoro.ai or/
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            (ii) any mobile based software applications/programs offered by
            zivoro.ai is protected under The Indian law.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You hereby acknowledge that the Services on company constitute
            purely original works and have been developed by applying standards
            of judgment and investing substantial time, effort, and money and
            constitutes valuable intellectual property of zivoro.ai and such
            others.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You thereby agree to protect the proprietary rights of company
            during and after the term of these Terms.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You may not selectively download any portions of the Platform. You
            may download material from the Platform only for the purpose
            intended by these Terms.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Any infringement shall lead to appropriate legal proceedings against
            You at appropriate forum for seeking all available remedies under
            applicable laws of the country.
          </li>
        </ul>
        <p className="sub-heading">GOVERNING LAW AND DISPUTE RESOLUTION</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            These Terms shall be governed by and construed in accordance with
            the laws of India. In the event of any dispute arising out of these
            Terms the same shall be settled by a binding arbitration conducted
            by a sole arbitrator, appointed jointly by both parties and governed
            by the Arbitration and Conciliation Act, 1996. The seat of
            arbitration shall be Bangalore, Karnataka, India.
          </li>
        </ul>
        <p className="sub-heading">ASSIGNMENT</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            It is expressly agreed by the parties that company may assign all or
            part of its rights or duties under these Terms without such
            assignment being considered a change to these Terms and without
            notice to You, except to the extent provided by law.
          </li>
        </ul>
        <p className="sub-heading">GRIEVANCE REDRESSAL MECHANISM</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            In accordance with the Information Technology Act, 2000 and Rules
            made thereunder, the details of the Grievance Officer are provided
            below:
          </li>
        </ul>
        <p style={{ fontWeight: "700" }}>
          Address: Jewel Nexus Technologies Private Limited
        </p>
        <p style={{ fontWeight: "700" }}>
          No.42, H.No.7, Sri Rama Building Royal Placid Layout, Phase 1
        </p>
        <p style={{ fontWeight: "700" }}>Haralur Main Road, Bangalore 560102</p>
        <p style={{ fontWeight: "700" }}>E-mail: shivank@zivoro.ai</p>
        <br></br>
        <p>
          If You wish to make a complaint regarding any violation of the
          provisions of these Terms, You may send a written complaint to the
          Grievance Officer, who shall redress the complaint in accordance with
          the provisions of the Information Technology Act, 2000 and Rules made
          thereunder.
        </p>

        <p className="sub-heading">HOW TO CONTACT US</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            If You have any questions or concerns about these Terms, please
            contact zivoro.ai at shivank@zivoro.ai
          </li>
        </ul>
        <p className="sub-heading">AMENDMENT OF TERMS</p>
        <ul
          style={{
            listStyleType: "disc",
            marginLeft: "10px",
            paddingLeft: "10px",
          }}
        >
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            Please note that these Terms may be amended from time to time by
            Company.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "10px" }}>
            You would be provided 7 days' prior notice to such changes/
            amendments which does not change the nature of the obligations cast
            upon you and Company.
          </li>
          <li style={{ textAlign: "justify", marginBottom: "50px" }}>
            In the event, any proposed changes or amendments to the Terms are
            adverse to or in any way detrimental to the You, then company shall
            provide You with 14 days' prior notice requiring You to opt out of
            the agreement/understanding on which company would provide the
            Services to You as recorded in these Terms. In the event that You do
            not respond to any such proposed change/amendment within 7 working
            days stating that You do not accept such change/amendment and wish
            to opt out of the Terms, then You would be deemed to have consented
            to such proposed change or amendment to these Terms.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default TermsAndConditions;
